// Mirrors the `sorted` scope on Rewards::Listing. The server already sends listings in
// this order; pages that re-derive it client-side (because they mutate the list without
// a round trip) sort with this, so the two orderings can't drift apart silently.
export default function sortListings(a, b) {
  // Gift cards first. The admin page renders its gift card outside these lists, so this
  // leg never fires there — it's kept so this stays a faithful copy of the SQL.
  if (!!a.is_gift_card !== !!b.is_gift_card) return a.is_gift_card ? -1 : 1;

  // Out of stock to the back. A null quantity means unlimited, i.e. in stock.
  const aOutOfStock = a.quantity_available === 0;
  const bOutOfStock = b.quantity_available === 0;
  if (aOutOfStock !== bOutOfStock) return aOutOfStock ? 1 : -1;

  // Ordinal ascending, unset last (the SQL's NULLS LAST). Both-unset falls through
  // rather than producing NaN from Infinity - Infinity.
  const aOrdinal = a.ordinal ?? Infinity;
  const bOrdinal = b.ordinal ?? Infinity;
  if (aOrdinal !== bOrdinal) return aOrdinal - bOrdinal;

  if (a.points_cost !== b.points_cost) return a.points_cost - b.points_cost;

  return a.name.localeCompare(b.name);
}
